import { Component, Input } from '@angular/core';
import { StreetAddress } from '../../../models/streetAddress/streetAddress';
import { IconType } from '../../../../../../../libs/Shared/components/icon/icon';

@Component({
  selector: 'app-terminal-shipping-form',
  templateUrl: './terminal-shipping-form.component.html',
  standalone: false,
})
export class TerminalShippingFormComponent {
  @Input() shippingAddress: Partial<StreetAddress>;
  @Input() hidden: boolean = false;

  IconType = IconType;

  constructor() {
    this.shippingAddress = StreetAddress.createEmpty();
  }

  clearShippingAddress() {
    this.shippingAddress = StreetAddress.createEmpty();
  }

  handleShippingAddressUpdated(address: Partial<StreetAddress>) {
    this.shippingAddress.street1 = address.street1;
    this.shippingAddress.street2 = address.street2;
    this.shippingAddress.city = address.city;
    this.shippingAddress.state = address.state;
    this.shippingAddress.postalCode = address.postalCode;
    this.shippingAddress.country = address.country;
  }

  handleRecipientNameUpdated(name: string) {
    this.shippingAddress.recipientLine1 = name;
  }

  toggle() {
    this.hidden = !this.hidden;
  }
}
